module.exports = __webpack_public_path__ + "static/media/pic3.e92e1dd8.jpg";